export default __webpack_public_path__ + "static/media/10.57aacfae.png";